import React, { forwardRef, useMemo, useState } from 'react'

import { Icon, Stack, colors, colors as zetColors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

import Alert from '../alert'
import TextInput from '../textInput'
import Dropdown from './dropDown'

const SelectDropDown = forwardRef(
  (
    {
      label = 'Select Dropdown',
      placeholder = 'Select',
      onChange,
      onBlur,
      value,
      errorMessage,
      isRequired = true,
      dropdownMode = 'single',
      isSearchable = false,
      searchEndPoint,
      options,
      fieldId,
      ocFieldCode,
      fieldDependency = '',
      autoCompleteLength = 3,
      disabled = false,
    },
    ref
  ) => {
    const [selectedValue, setSelectedValue] = useState<string>(value)
    const [dropDownVisible, setDropDownVisible] = useState(false)

    const onDismiss = () => {
      setDropDownVisible(false)
    }

    const setOptionOnSelect = (val: string, displayText: string) => {
      if (isSearchable && !options?.find((item) => item.optionId === val)) {
        options?.push({
          optionId: val,
          optionValue: displayText,
        })
      }
    }

    const onSelect = (val: string, displayText: string) => {
      setSelectedValue(displayText)
      onChange(val)
      onBlur()
    }

    const getDisplayText = useMemo(() => {
      const selectedObj = options?.find(
        (option) => option.optionId === selectedValue
      )
      return selectedObj?.optionValue ?? selectedValue
    }, [selectedValue])

    const onOpenDropdown = () => {
      if (!disabled) {
        setDropDownVisible(true)
      }
    }
    return (
      <Stack>
        <Pressable onPress={onOpenDropdown}>
          <Stack pointerEvents="none">
            <TextInput
              isEditable={false}
              placeholder={placeholder}
              onBlur={onBlur}
              iconRight={
                <Icon
                  type="ArrowDown"
                  color={zetColors.grays[80]}
                  className="mr-1 mt-1"
                />
              }
              style={{
                color: zetColors.grays[100],
                fontFamily: 'Graphie-Book',
                margin: 0,
              }}
              value={
                dropdownMode === 'multi'
                  ? selectedValue.toString().substring(0, 35)
                  : getDisplayText
              }
              label={label}
              isRequired={isRequired}
              errorMessage={errorMessage}
              disabled={true}
              noDisabledStyle={!disabled}
            />
          </Stack>
        </Pressable>
        {false && (
          <Alert
            icon="DeliveryOutlined"
            text={'The card will be dispatched to your current address.'}
            bgColor={colors.primary[10]}
          />
        )}
        <Dropdown
          ref={ref}
          label={label}
          dropdownMode={dropdownMode}
          isSearchable={isSearchable}
          onDismiss={onDismiss}
          selectedValue={selectedValue}
          onSelect={onSelect}
          setDropDownVisible={setDropDownVisible}
          dropDownVisible={dropDownVisible}
          searchEndPoint={searchEndPoint}
          options={options}
          fieldId={fieldId}
          fieldDependency={fieldDependency}
          ocFieldCode={ocFieldCode}
          autoCompleteLength={autoCompleteLength}
        />
      </Stack>
    )
  }
)

export default SelectDropDown
